module.exports = __webpack_public_path__ + "img/tooltip-actual.d4599134.svg";